import React from 'react';

const cardStyles = {
  container: {
    backgroundColor: 'var(--color-bg-card)',
    borderRadius: 'var(--radius-lg)',
    border: '1px solid rgba(212, 175, 55, 0.1)',
    boxShadow: 'var(--shadow-md)',
    overflow: 'hidden',
    transition: 'all var(--transition-normal)',
  },
  header: {
    padding: 'var(--space-md) var(--space-lg)',
    borderBottom: '1px solid rgba(212, 175, 55, 0.1)',
    fontFamily: 'var(--font-display)',
    fontSize: '1.1rem',
    fontWeight: 600,
    letterSpacing: '0.03em',
    color: 'var(--color-primary)',
  },
  body: {
    padding: 'var(--space-lg)',
  },
};

export default function Card({ children, header, hoverable = false, style, className, onClick }) {
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        ...cardStyles.container,
        ...(hoverable ? { cursor: 'pointer' } : {}),
        ...style,
      }}
      onMouseEnter={(e) => {
        if (hoverable) {
          e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.3)';
          e.currentTarget.style.boxShadow = 'var(--shadow-lg)';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }
      }}
      onMouseLeave={(e) => {
        if (hoverable) {
          e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.1)';
          e.currentTarget.style.boxShadow = 'var(--shadow-md)';
          e.currentTarget.style.transform = 'translateY(0)';
        }
      }}
    >
      {header && <div style={cardStyles.header}>{header}</div>}
      <div style={cardStyles.body}>{children}</div>
    </div>
  );
}
